import {Component, Input, Output, EventEmitter, ElementRef, ViewChild} from "@angular/core";


export class ModalHeader {

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "modal-header",
    template: `<ng-content></ng-content>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class ModalContent {

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "modal-content",
    template: `<ng-content></ng-content>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class ModalFooter {

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "modal-footer",
    template: `<ng-content></ng-content>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class Modal {

    // -------------------------------------------------------------------------
    // Inputs
    // -------------------------------------------------------------------------

    
    public modalClass: string;

    
    public closeOnEscape: boolean = true;

    
    public closeOnOutsideClick: boolean = true;

    
    public title: string;

    
    public hideCloseButton = false;

    
    public cancelButtonLabel: string;

    
    public submitButtonLabel: string;

    // -------------------------------------------------------------------------
    // Outputs
    // -------------------------------------------------------------------------

    
    public onOpen = new EventEmitter(false);

    
    public onClose = new EventEmitter(false);

    
    public onSubmit = new EventEmitter(false);

    // -------------------------------------------------------------------------
    // Public properties
    // -------------------------------------------------------------------------

    public isOpened = false;

    // -------------------------------------------------------------------------
    // Private properties
    // -------------------------------------------------------------------------

    
    public modalRoot: ElementRef;

    private backdropElement: HTMLElement;

    // -------------------------------------------------------------------------
    // Constructor
    // -------------------------------------------------------------------------

    constructor() {
        this.createBackDrop();
    }

    // -------------------------------------------------------------------------
    // Lifecycle Methods
    // -------------------------------------------------------------------------

    ngOnDestroy() {
        document.body.className = document.body.className.replace(/modal-open\b/, "");
        if (this.backdropElement && this.backdropElement.parentNode === document.body)
            document.body.removeChild(this.backdropElement);
    }

    // -------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------

    open(...args: any[]) {
        if (this.isOpened) return;
        
        this.isOpened = true;
        document.body.appendChild(this.backdropElement);

        window.setTimeout(() => {
            this.modalRoot.nativeElement.focus();
            this.onOpen.emit(args);
        }, 0);

        document.body.className += " modal-open";
    }

    close(...args: any[]) {
        if (!this.isOpened)
            return;

        document.body.removeChild(this.backdropElement);
        document.body.className = document.body.className.replace(/modal-open\b/, "");

        this.isOpened = false;
        this.onClose.emit(args);
    }

    // -------------------------------------------------------------------------
    // Private Methods
    // -------------------------------------------------------------------------

    public preventClosing(event: MouseEvent) {
        event.stopPropagation();
    }

    private createBackDrop() {
        this.backdropElement = document.createElement("div");
        this.backdropElement.classList.add("modal-backdrop");
        this.backdropElement.classList.add("fade");
        this.backdropElement.classList.add("in");
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "modal",
    template: `
<div class="modal" 
     tabindex="-1"
     role="dialog"
     #modalRoot
     (keydown.esc)="closeOnEscape ? close() : 0"
     [ngClass]="{ in: isOpened, fade: isOpened }"
     [ngStyle]="{ display: isOpened ? 'block' : 'none' }"
     (click)="closeOnOutsideClick ? close() : 0">
    <div [class]="'modal-dialog ' + modalClass" (click)="preventClosing($event)">
        <div class="modal-content" tabindex="0" *ngIf="isOpened">
            <div class="modal-header">
                <button *ngIf="!hideCloseButton" type="button" class="close" data-dismiss="modal" [attr.aria-label]="cancelButtonLabel || 'Close'" (click)="close()"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title" *ngIf="title">{{ title }}</h4>
                <ng-content select="modal-header"></ng-content>
            </div>
            <div class="modal-body">
                <ng-content select="modal-content"></ng-content>
            </div>
            <div class="modal-footer">
                <ng-content select="modal-footer"></ng-content>
                <button *ngIf="cancelButtonLabel" type="button" class="btn btn-default" data-dismiss="modal" (click)="close()">{{ cancelButtonLabel }}</button>
                <button *ngIf="submitButtonLabel" type="button" class="btn btn-primary" (click)="onSubmit.emit(undefined)">{{ submitButtonLabel }}</button>
            </div>
        </div>
    </div>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'modalClass': [{ type: Input },],
'closeOnEscape': [{ type: Input },],
'closeOnOutsideClick': [{ type: Input },],
'title': [{ type: Input },],
'hideCloseButton': [{ type: Input },],
'cancelButtonLabel': [{ type: Input },],
'submitButtonLabel': [{ type: Input },],
'onOpen': [{ type: Output },],
'onClose': [{ type: Output },],
'onSubmit': [{ type: Output },],
'modalRoot': [{ type: ViewChild, args: ["modalRoot", ] },],
};
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
